// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"1b7333e0","1395":"1b7333e0","3761":"1b7333e0","5309":"1b7333e0","5469":"1b7333e0","5609":"1b7333e0","5617":"1b7333e0","8190":"1b7333e0","9591":"1b7333e0"}[chunkId] + ".chunk.css";
};